module.exports = __webpack_public_path__ + "img/dub-play.338c260b.png";